import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CloudUpload, X } from "lucide-react";
import { toast } from "sonner";

const DISMISS_KEY = "sp-guest-notice-hidden";

export function SaveProgressButton({ className = "" }) {
  return (
    <Link to="/login" data-testid="header-save-progress-button"
      className={`inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full bg-amber-400 text-black text-xs sm:text-sm font-bold shadow-[0_0_24px_rgba(251,191,36,0.35)] transition-transform hover:scale-105 active:scale-95 ${className}`}>
      <CloudUpload className="h-4 w-4" /> <span className="sm:hidden">Save</span><span className="hidden sm:inline">Save progress</span>
    </Link>
  );
}

export function GuestNotice({ dismissible = true }) {
  const [hidden, setHidden] = useState(() => dismissible && sessionStorage.getItem(DISMISS_KEY) === "1");
  if (hidden) return null;
  const hide = () => { sessionStorage.setItem(DISMISS_KEY, "1"); setHidden(true); };
  return (
    <div data-testid="guest-notice"
      className="max-w-6xl mx-auto mb-6 flex items-start gap-3 rounded-2xl border border-amber-400/50 bg-amber-400/10 px-4 py-3 fade-up">
      <AlertTriangle className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
      <p className="text-sm flex-1">
        <span className="font-bold">You're not logged in.</span>{" "}
        <span className="text-muted-foreground">Your swipes and settings are only kept in this browser and could be lost if it's cleared or you switch devices.</span>{" "}
        <Link to="/login" className="font-bold text-amber-600 dark:text-amber-400 underline-offset-4 hover:underline whitespace-nowrap" data-testid="guest-notice-login-link">
          Log in to save them
        </Link>
      </p>
      {dismissible && (
        <button onClick={hide} aria-label="Hide for now" data-testid="guest-notice-dismiss" className="text-muted-foreground hover:text-foreground">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export function announceSaved(user, wasGuest) {
  if (!wasGuest) return;
  const n = user.merged || 0;
  toast.success("Progress saved to your account", {
    description: n ? `${n} movie${n === 1 ? " from this browser is" : "s from this browser are"} now in your lists.` : "Your account is all set.",
  });
}
